import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  transfersShippingService,
  type TransfersShippingCompleteParams,
} from '@/services/transfers-shipping';
import { queryKeys } from '@/lib/queryKeys';
import { useNotifications } from '@/stores/useNotificationStore';
import { getErrorMessage } from '@/utils/httpClient';

export const useCompleteTransfer = () => {
  const queryClient = useQueryClient();
  const notifications = useNotifications();

  return useMutation({
    mutationFn: (params: TransfersShippingCompleteParams) =>
      transfersShippingService.completeTransfer(params),
    onSuccess: (result) => {
      notifications.success(
        'Transfer Complete',
        `${result.totalQuantity} item${result.totalQuantity === 1 ? '' : 's'} transferred.`,
      );
      void queryClient.invalidateQueries({ queryKey: ['asset-inventory'] });
      void queryClient.invalidateQueries({ queryKey: queryKeys.transfersShipping.all });
      void queryClient.invalidateQueries({ queryKey: queryKeys.transactions.all });
    },
    onError: (error) => {
      notifications.error('Transfer Failed', getErrorMessage(error));
    },
  });
};
